import api from './api';

const chatAccessService = {
  getMeta() {
    return api.get('/chat/access/meta');
  },

  listPairs({ practiceId, pairType, managerUserId }) {
    return api.get('/chat/access', {
      params: {
        practiceId,
        pairType,
        manager_user_id: managerUserId,
      },
    });
  },

  upsertGrant(payload) {
    return api.put('/chat/access', payload);
  },

  bulkUpsertGrants(payload) {
    return api.put('/chat/access/bulk', payload);
  },
};

export default chatAccessService;
